import React, { useEffect, useState } from "react";
import { Card, Modal, Spin, Typography } from "antd";
import { useTranslation } from "react-i18next";
import LoginService from "services/loginService";
import moment from "moment";
import CrimeRecord from "./CrimeRecord";
import { CRIMINAL_ORIGIN_DISPLAY_MAPPING } from "constants/common";
import { CRIMINAL_STATUS } from "constants/common";
import { DATE_DISPLAY_FORMAT_HOURS } from "constants/dateFormats";

export const ModalCrime = (props) => {
  const { plateNumber, onClose } = props;
  const { t: translation } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [criminalRecordList, setCriminalRecordList] = useState({});
  const [criminalRecordListGroupByOrigin, setCriminalRecordListGroupByOrigin] = useState({});

  function _groupingCriminalRecordListByOrigin(criminalRecordListData) {
    if (!Array.isArray(criminalRecordListData)) return [];
    const groupMap = {};
    // Map records by origin key (not display title)
    criminalRecordListData.forEach(record => {
      const originKey = record.crimeRecordOrigin;
      if (!groupMap[originKey]) {
        groupMap[originKey] = [];
      }
      groupMap[originKey].push(record);
    });

    const _output = [];
    const originKeys = Object.keys(CRIMINAL_ORIGIN_DISPLAY_MAPPING);
    for (let i = 0; i < originKeys.length; i++) {
      const originKey = originKeys[i];
      const records = groupMap[originKey] || [];
      // Count only records that are not NOT_CRIMINAL or API_ERROR
      let criminalCount = 0;
      if (records && records.length > 0) {
        for (let j = 0; j < records.length; j++) {
          if (
            records[j].crimeRecordStatus !== CRIMINAL_STATUS.NOT_CRIMINAL &&
            records[j].crimeRecordStatus !== CRIMINAL_STATUS.API_ERROR
          ) {
            criminalCount++;
          }
        }
      }
      // Only push if there is at least one record for this origin
      if (records.length > 0) {
        _output.push({
          criminalOrigin: originKey,
          criminalOriginTitle:
            CRIMINAL_ORIGIN_DISPLAY_MAPPING[originKey] + (criminalCount ? ` (${criminalCount} Lỗi vi phạm)` : ""),
          criminalRecordListGrouping: records,
          criminalCount,
        });
      }
    }
    return _output;
  }

  function _mappingDisplayCriminalDetail(criminalRecordList) {
    if (!criminalRecordList || criminalRecordList.length === 0) {
      return (
        <Typography.Text type="success">
          {"Không có lỗi vi phạm"}
        </Typography.Text>
      );
    }
    if (criminalRecordList[0] && criminalRecordList[0].crimeRecordStatus === CRIMINAL_STATUS.NOT_CRIMINAL) {
      return (
        <Typography.Text type="success">
          {criminalRecordList[0]?.crimeRecordContent || "Không có lỗi vi phạm"}
        </Typography.Text>
      );
    } else if (criminalRecordList[0] && criminalRecordList[0].crimeRecordStatus === CRIMINAL_STATUS.API_ERROR) {
      return (
        <Typography.Text type="danger">
          {criminalRecordList[0]?.crimeRecordContent || "Lỗi tra cứu thông tin"}
        </Typography.Text>
      );
    } else {
      return (
        <>
          {criminalRecordList.map(criminalRecord => (
            <CrimeRecord key={criminalRecord.crimeRecordId} record={criminalRecord} />
          ))}
        </>
      );
    }
  }

  function handleFind() {
    setLoading(true);
    error && setError("");
    LoginService.getDetailPunish({
      filter: {
        customerRecordPlatenumber: plateNumber,
      },
    }).then((result) => {
      if (result?.data && result?.data.length > 0) {
        setCriminalRecordList(result?.data);
        setCriminalRecordListGroupByOrigin(_groupingCriminalRecordListByOrigin(result?.data));
      } else {
        setCriminalRecordList([]);
        setCriminalRecordListGroupByOrigin([]);
        setError(translation("management.none"));
      }
      setLoading(false);
    });
  }

  useEffect(() => {
    handleFind();
  }, []);

  if (loading) {
    return <Spin />;
  }

  return (
    <Modal
      visible
      title={
        <div className="text-center">
          <h3>Kết quả tra cứu phạt nguội</h3>
          <div>
            <h3>
              Biển số xe:{" "}
              <Typography.Text strong>{plateNumber}</Typography.Text>
            </h3>
          </div>
        </div>
      }
      onCancel={onClose}
      footer={null}
      wrapClassName="punish_modal--root"
      width={800}
    >
      <>
        {criminalRecordListGroupByOrigin && criminalRecordListGroupByOrigin.length > 0 ? (
          criminalRecordListGroupByOrigin.map((_criminalRecordListByOrigin) => (
            <Card sx={{ m: 2 }} key={_criminalRecordListByOrigin.criminalOriginTitle}>
              <Typography.Title level={4} className="mb-1">
                Nguồn: {_criminalRecordListByOrigin.criminalOriginTitle}
              </Typography.Title>
              {_criminalRecordListByOrigin.criminalRecordListGrouping ? _mappingDisplayCriminalDetail(_criminalRecordListByOrigin.criminalRecordListGrouping) : null}
            </Card>
          ))
        ) : (
          <Typography.Text type="danger">{error}</Typography.Text>
        )}
      </>
    </Modal>
  );
};
